import React from 'react'
import styled from 'styled-components'
import ChartSection from '../ChartSection'
import StatsSection from '../StatsSection'

const ChartStatsContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: stretch;
  margin-bottom: 48px;
  width: 100%;
  min-height: 481px;

  /* Chart section takes most of the space */
  > :first-child {
    flex: 0 0 880px; /* Fixed width for chart */
    min-width: 0;
  }

  /* Stats section takes remaining space */
  > :last-child {
    flex: 1;
    min-width: 300px; /* Minimum width to prevent too small stats */
  }

  @media screen and (max-width: 1200px) {
    > :first-child {
      flex: 2; /* Chart takes 2/3 of space on smaller screens */
    }

    > :last-child {
      flex: 1; /* Stats takes 1/3 of space on smaller screens */
      min-width: 250px;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    > :first-child,
    > :last-child {
      flex: none;
      min-width: unset;
    }
  }
`

const ChartStatsSection = ({
  address,
  backgroundColor,
  price,
  liquidity,
  liquidityChange,
  liquidityChangeUSD,
  volume,
  volumeChange,
  volumeChangeUSD,
  oneDayTxns,
  txnChange,
  txnChangeRaw,
}) => {
  return (
    <ChartStatsContainer>
      <ChartSection address={address} backgroundColor={backgroundColor} price={price} />
      <StatsSection
        liquidity={liquidity}
        liquidityChange={liquidityChange}
        liquidityChangeUSD={liquidityChangeUSD}
        volume={volume}
        volumeChange={volumeChange}
        volumeChangeUSD={volumeChangeUSD}
        oneDayTxns={oneDayTxns}
        txnChange={txnChange}
        txnChangeRaw={txnChangeRaw}
      />
    </ChartStatsContainer>
  )
}

export default ChartStatsSection
